import { Flow_0_0_2, getFullItemOne, getFullItemTwo } from '@flexus/core';
import { map, skipWhile, filter, take, pluck, switchMap } from 'rxjs/operators';
import { environment } from 'apps/studio/src/environments/environment';
import { iif, of } from 'rxjs';

export const SIL_VIEW_JOB_SUMMARY: Flow_0_0_2 = {
	id: 'JobSummary',
	itemType: 'flow',
	name: 'View Job Summary',
	excludeForOnlyStates: [169],
	excludeForOnlyRoles: [18],
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				skipWhile(x => !x),
				map(itemOne => {
					if (itemOne && itemOne?.applicant && itemOne?.applicant?.information) {
						return `Summary for this job on policy - ${itemOne?.loan_information?.mavenclaimnumber}  -  ${itemOne?.applicant?.surname}`;
						// return `Job Summary : ${itemOne?.loan_information?.mavenclaimnumber}  -  ${itemOne?.applicant?.surname}`;
					} else {
						return 'Job Summary';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'JobSummary',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		JobSummary: {
			component: {
				children: [
					{
						component: 'JobSummaryComponent',
						inputs: { title: 'Job Information', assessorName$: 'assessorName', teamLead$: 'teamLeader' }
					}
				]
			},
			serverCalls: {
				assessorName: {
					errorMessage: 'Something went wrong with claim information!',
					directCall: (http, store, sq) => {
						return store.select(getFullItemTwo).pipe(
							filter(x => !!x),
							take(1),
							pluck('assessor'),
							switchMap(assessor => {
								return iif(
									() => assessor,
									http
										.post(environment.api_url + 'v1/staff_action/get_staff_member_names', {
											ids: [assessor]
										})
										.pipe(
											map((data: any) => {
												const namesMapper = data.payload;
												return namesMapper[assessor];
											})
										),
									of('Not Assigned')
								);
							})
						);
					}
				},
				teamLeader: {
					errorMessage: 'Something went wrong with claim information!',
					directCall: (http, store) =>
						store.select(getFullItemTwo).pipe(
							skipWhile(itemTwo => !itemTwo),
							take(1),
							pluck('team_leader'),
							map(teamLeader => (teamLeader && teamLeader.full_name) || 'Not Assigned')
						)
				}
			}
		}
	}
};
